export default "__VITE_ASSET__6f3e80d5__"